import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import NavLink from './nav_link';
// import all nav lists
import GeneralList from './msLinks/msList--General';
import AccountList from './msLinks/msList--AccountAdmin';
import PortalAdminList from './msLinks/msList--PortalAdmin';
import UsingPortalsList from './msLinks/msList--UsingPortals';
import SigniantAppList from './msLinks/msList--SigniantApp';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ProductHeadingDivider from './ProductHeadingDivider';

const styles = (theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        textAlign: 'left',
        paddingRight: 0,
    },
    productHeading: {
        fontWeight: 'bold',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem',
    },
    subheading: {
        maxHeight: '48px',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem',
        lineHeight: '1.46429em',
        paddingRight: '1.0rem',
    },
    subheadingActive: {
        maxHeight: '40px',
        color: 'rgba(0, 0, 0, 0.95)',
        fontSize: '1rem',
        lineHeight: '1.46429em',
        paddingTop: '1.0rem',
    },
    chevron: {
        fill: '#262626',
        marginRight: '-1rem',
    },
});

class MSList extends React.Component {
    state = {
        openMSGeneral: false,
        openMSAccount: false,
        openMSPortalAdmin: false,
        openMSUsingPortals: false,
        openMSSigniantApp: false,
        openSDCXServer: false,
    };
    handleClickMSGeneral = (event) => {
        let current = !this.state.openMSGeneral;
        if (!event) {
            current = true;
        }
        this.setState({
            openMSGeneral: current,
        });
    };
    handleClickMSAccount = (event) => {
        let current = !this.state.openMSAccount;
        if (!event) {
            current = true;
        }
        this.setState({
            openMSAccount: current,
        });
    };
    handleClickMSPortalAdmin = (event) => {
        let current = !this.state.openMSPortalAdmin;
        if (!event) {
            current = true;
        }
        this.setState({
            openMSPortalAdmin: current,
        });
    };
    handleClickMSPortalMember = (event) => {
        let current = !this.state.openMSUsingPortals;
        if (!event) {
            current = true;
        }
        this.setState({
            openMSUsingPortals: current,
        });
    };
    handleClickMSSigApp = (event) => {
        let current = !this.state.openMSSigniantApp;
        if (!event) {
            current = true;
        }
        this.setState({
            openMSSigniantApp: current,
        });
    };
    handleClickSDCXServer = (event) => {
        let current = !this.state.openSDCXServer;
        if (!event) {
            current = true;
        }
        this.setState({
            openSDCXServer: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <List>
                    <NavLink onClick={this.preventAction} to="/media-shuttle/general/">
                        <ListItem
                            button
                            onClick={this.handleClickMSGeneral}
                            isActive={this.state.openMSGeneral}
                            className={classes.subheading}
                        >
                            <ListItemText secondary="General" />
                            {this.state.openMSGeneral ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>

                    <GeneralList
                        isOpen={this.state.openMSGeneral}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                        onActive={this.handleClickMSGeneral}
                    />

                    <NavLink onClick={this.preventAction} to="/media-shuttle/account-administration/">
                        <ListItem
                            button
                            onClick={this.handleClickMSAccount}
                            isActive={this.state.openMSAccount}
                            className={classes.subheading}
                        >
                            <ListItemText secondary="IT Administration" />
                            {this.state.openMSAccount ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>

                    <AccountList
                        isOpen={this.state.openMSAccount}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                        onActive={this.handleClickMSAccount}
                    />

                    <NavLink onClick={this.preventAction} to="/media-shuttle/portal-administration/">
                        <ListItem button onClick={this.handleClickMSPortalAdmin} className={classes.subheading}>
                            <ListItemText secondary="Operations Administration" />
                            {this.state.openMSPortalAdmin ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>

                    <PortalAdminList
                        isOpen={this.state.openMSPortalAdmin}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                        onActive={this.handleClickMSPortalAdmin}
                    />

                    <NavLink onClick={this.preventAction} to="/media-shuttle/using-portals/">
                        <ListItem button onClick={this.handleClickMSPortalMember} className={classes.subheading}>
                            <ListItemText secondary="Using Portals" />
                            {this.state.openMSUsingPortals ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>

                    <UsingPortalsList
                        isOpen={this.state.openMSUsingPortals}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                        onActive={this.handleClickMSPortalMember}
                    />

                    <NavLink onClick={this.preventAction} to="/media-shuttle/signiant-app/">
                        <ListItem button onClick={this.handleClickMSSigApp} className={classes.subheading}>
                            <ListItemText secondary="Signiant App" />
                            {this.state.openMSSigniantApp ? (
                                <ExpandLess className={classes.chevron} />
                            ) : (
                                <ExpandMore className={classes.chevron} />
                            )}
                        </ListItem>
                        <ProductHeadingDivider />
                    </NavLink>

                    <SigniantAppList
                        isOpen={this.state.openMSSigniantApp}
                        handleDrawerToggle={this.props.handleDrawerToggle}
                        onActive={this.handleClickMSSigApp}
                    />
                </List>
            </React.Fragment>
        );
    }
}

MSList.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(MSList);
